export default __webpack_public_path__ + "static/media/stormcharge.ae7c9b46.png";